import * as React from 'react';

interface CheckmarkIconProps {
  fill?: string
}

const CheckmarkIcon: React.FC<CheckmarkIconProps> = ({ fill = '#4a4eaf' }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 1200 1200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m1128.7 33.566c33.566-8.3906 96.504 0 62.938 25.176-281.12 222.38-595.8 641.96-746.85 977.62-50.352 96.504-104.89 121.68-172.03 134.27-37.762-138.46-146.85-432.17-272.73-478.32 62.937-67.133 121.68-100.7 172.03-100.7 75.523 0 146.85 184.62 176.22 255.95 167.83-306.29 486.71-641.96 780.42-813.98z"
      fill={fill}
    />
  </svg>
)

export default CheckmarkIcon
